module.exports = __webpack_public_path__ + "static/media/x2y2-over.d1fb2eed.png";